export default __webpack_public_path__ + "static/media/cover-letter.24f91e6f.svg";